import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import SalesPerson from "./salesPerson";
import { useTab } from "../../contexts/useTab";
import BusinessSupportStaff from "./businessSupportStaff";
import iconButton from "../../assets/images/employee/icon-button.svg";
import FormEmployee from "../../components/form/formEmployee";
import { useEmployee } from "../../hooks/useEmployee";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { employeeCall } from "../../api/employee";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import { exportFile } from "../../utils/tools";
import { businessCategoryCall } from "../../api/businessCategory";
import PopupImport from "../../components/popup/PopupImport";
import IconFile from "../../assets/images/booking/upfile.svg";
import SalesRelative from "./salesRelative";
import FormRelative from "../../components/form/formRelative";

const columnMappingEmployee = {
  "Mã nhân viên": "code",
  "Họ tên": "fullName",
  "Mã NN": "employeeCodeId",
  "Mã người giới thiệu": "referralCodeId",
  "Khối nhân sự": "department",
  SĐT: "phone",
  Email: "email",
  TTHĐ: "status",
  "Mã khối": "saleBlockCode",
  Khối: "saleBlockName",
  "Mã vùng": "saleAreaCode",

  Vùng: "saleAreaName",
  "Chi nhánh": "branchName",
  "Chức vụ": "jobPositionName",
  "Chức phòng ban": "supportDepartmentName",
  "Chức danh": "jobTitleName",
  "Loại nhân viên kinh doanh": "businessCategoryName",
  "Loại bảo lãnh": "guaranteeTypeName",
  "Ngày bảo lãnh": "guaranteeDate",
  "Ngày ký quỹ": "depositDate",
  "Ngày sinh": "dateOfBirth",

  "Giới tính": "gender",
  "Số CCCD": "identificationNumber",
  "Ngày cấp CCCD": "dateOfIdentification",
  "Nơi cấp CCCD": "placeOfIdentification",
  "Chỗ ở hiện tại": "currentAddress",
  "Địa chỉ thường trú": "permanentAddress",
  STK: "bankAccount",
  "Ngân hàng": "bankName",
  "Mã số thuế": "taxCode",
  "Ngày vào làm": "startTime",

  "Ngày nghỉ": "endTime",
};

const columnMappingLeaveBalanceEmployee = {
  "Mã nhân viên": "employeeCode",
  "Họ tên": "employeeName",
  Năm: "year",
  "Ngày nghỉ phép năm": "remainingLeave",
  "Ngày phép bù": "compensatoryLeave",
};

export default function Employee() {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenRelative,
    onOpen: onOpenRelative,
    onClose: onCloseRelative,
    onToggle: onToggleRelative,
  } = useDisclosure();
  const [paramSalesPerson, setParamSalesPerson] = useState(null);
  const [paramBusinessSupportStaff, setParamBusinessSupportStaff] =
    useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImportLeaveBalanceVisible, setPopupImportLeaveBalanceVisible] =
    useState(false);

  const { employeeTab, setEmployeeTab } = useTab();
  const dataSalesPerson = useEmployee(1);
  const dataBusinessSupportStaff = useEmployee(0);

  const { refetch, isRefetching } = useEmployee(employeeTab);

  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const tabEmployee = [
    {
      title: "Cộng tác viên",
      content: (
        <SalesRelative
          department={3}
          isRefetchingWithCreate={isRefetching}
          paramData={setParamSalesPerson}
        />
      ),
    },
    {
      title: "Nhân viên khối kinh doanh",
      content: (
        <SalesPerson
          department={1}
          isRefetchingWithCreate={isRefetching}
          paramData={setParamSalesPerson}
        />
      ),
    },
    {
      title: "NV khối hỗ trợ kinh doanh",
      content: (
        <BusinessSupportStaff
          department={0}
          isRefetchingWithCreate={isRefetching}
          paramData={setParamBusinessSupportStaff}
        />
      ),
    },
    {
      title: "Ban giám đốc",
      content: (
        <SalesPerson
          department={2}
          isRefetchingWithCreate={isRefetching}
          paramData={setParamSalesPerson}
        />
      ),
    },
  ];
  // Thứ tự HIỂN THỊ tab: đưa "Cộng tác viên" (index 0) xuống cuối.
  // Giữ nguyên index gốc để không đổi logic lọc theo department / export.
  const tabOrder = [1, 2, 3, 0];
  const onSubmit = async (data) => {
    const toastCreate = toast.loading("Đang thêm nhân viên ...");

    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );
      if (filteredData?.file) {
        const { filePath } = await commonCall.uploadAvatar(filteredData?.file);
        if (filePath) filteredData.avatar = filePath;
      }
      delete filteredData.file;
      // test
      // filteredData.code = `MSH${Math.floor(1000 + Math.random() * 9000)}`;
      //
      await employeeCall.create({ ...filteredData });
      await refetch();
      onToggle();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitRelative = async (data) => {
    const toastCreate = toast.loading("Đang thêm cộng tác viên ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );
      if (filteredData?.file) {
        const { filePath } = await commonCall.uploadAvatar(filteredData?.file);
        if (filePath) filteredData.avatar = filePath;
      }
      delete filteredData.file;
      await employeeCall.createRelative({ ...filteredData });
      await refetch();
      onToggleRelative();
      toast.success("Thêm cộng tác viên thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleExport = async () => {
    const employeeColumnMapping = {
      code: "Mã Nhân Viên",
      status: "Trạng Thái",
      department: "Loại Nhân Viên",
      businessCategory: "Loại Nhân Sự",
      fullName: "Họ Và Tên",
      dateOfBirth: "Ngày Sinh",
      phone: "Số Điện Thoại",
      email: "Địa Chỉ Email",
      currentAddress: "Địa Chỉ Hiện Tại",
      identificationNumber: "Căn Cước Công Dân",
      dateOfIdentification: "Ngày Cấp Căn Cước Công Dân",
      placeOfIdentification: "Nơi Cấp Căn Cước Công Dân",
      permanentAddress: "Địa Chỉ Thường Trú",
      taxCode: "Mã Số Thuế",
      bankAccount: "Tài Khoản Ngân Hàng",
      bankName: "Tên Ngân Hàng",
      gender: "Giới Tính",
      supportDepartment: "Phòng Ban",
      jobTitle: "Chức Danh",
      jobPosition: "Chức Vụ",
      saleBlock: "Khối",
      saleArea: "Vùng",
      branch: "Chi Nhánh",
      startTime: "Ngày Bắt Đầu Làm Việc",
      endTime: "Ngày Kết Thúc Làm Việc",
      remainingLeave: "Số Ngày Phép Còn Lại",
      compensatoryLeave: "Số Ngày Phép bù",
      isBrokerDebtCertificate: "Trạng Thái Chứng Chỉ Môi Giới",
      isProfileCompleted: "Trạng Thái Hoàn Thiện Hồ Sơ",
      referralCodeId: "Mã Nhân Viên Giới Thiệu",
    };

    if (Number(employeeTab) === 3) {
      const entries = dataBusinessSupportStaff?.entries || 999;
      const data = await businessCategoryCall.export(
        entries,
        2,
        paramSalesPerson,
      );
      if (data) {
        exportFile(
          data,
          employeeColumnMapping,
          "bang_nhan_vien_ban_giam_doc.xlsx",
        );
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else if (Number(employeeTab) === 2) {
      const entries = dataBusinessSupportStaff?.entries || 999;
      const data = await businessCategoryCall.export(
        entries,
        0,
        paramBusinessSupportStaff,
      );
      if (data) {
        exportFile(
          data,
          employeeColumnMapping,
          "bang_nhan_vien_khoi_ho_tro_kinh_doanh.xlsx",
        );
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else if (Number(employeeTab) === 1) {
      const entries = dataSalesPerson?.entries || 999;
      const data = await businessCategoryCall.export(
        entries,
        1,
        paramSalesPerson,
      );
      if (data) {
        exportFile(
          data,
          employeeColumnMapping,
          "bang_nhan_vien_khoi_kinh_doanh.xlsx",
        );
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else {
      const entries = dataSalesPerson?.entries || 999;
      const data = await businessCategoryCall.export(
        entries,
        3,
        paramSalesPerson,
      );
      if (data) {
        exportFile(data, employeeColumnMapping, "bang_cong_tac_vien.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    }
  };

  const handleEmployeeExportSample = () => {
    const columnMapping = {
      code: "Mã nhân viên",
      fullName: "Họ tên",
      employeeCodeId: "Mã NN",
      referralCodeId: "Mã người giới thiệu",
      department: "Khối nhân sự",
      phone: "SĐT",
      email: "Email",
      status: "TTHĐ",
      saleBlockCode: "Mã khối",
      saleBlockName: "Khối",
      saleAreaCode: "Mã vùng",
      saleAreaName: "Vùng",
      branchName: "Chi nhánh",
      jobPositionName: "Chức vụ",
      supportDepartmentName: "Chức phòng ban",
      jobTitleName: "Chức danh",
      businessCategoryName: "Loại nhân viên kinh doanh",
      guaranteeTypeName: "Loại bảo lãnh",
      guaranteeDate: "Ngày bảo lãnh",
      depositDate: "Ngày ký quỹ",
      dateOfBirth: "Ngày sinh",
      gender: "Giới tính",
      identificationNumber: "Số CCCD",
      dateOfIdentification: "Ngày cấp CCCD",
      placeOfIdentification: "Nơi cấp CCCD",
      currentAddress: "Chỗ ở hiện tại",
      permanentAddress: "Địa chỉ thường trú",
      bankAccount: "STK",
      bankName: "Ngân hàng",
      taxCode: "Mã số thuế",
      startTime: "Ngày vào làm",
      endTime: "Ngày nghỉ",
    };

    const data = [
      {
        code: "CTV002222",
        fullName: "Họ Tên Test3",
        employeeCodeId: "",
        referralCodeId: "TEST1",
        department: "Khối kinh doanh",
        phone: "09295871222",
        email: "CTV002222@gmail.com",
        status: "Đang hoạt động",
        saleBlockCode: "CTV000373",
        saleBlockName: "Hà Minh Thức",
        saleAreaCode: "CTV000373",
        saleAreaName: "Hà Minh Thức",
        branchName: "Hội sở Hà Nội",
        jobPositionName: "Nhân viên",
        supportDepartmentName: "",
        jobTitleName: "Nhân viên",
        businessCategoryName: "CVKD",
        guaranteeTypeName: "",
        guaranteeDate: "",
        depositDate: "",
        dateOfBirth: "22/09/2002",
        gender: "Name",
        identificationNumber: "092911222",
        dateOfIdentification: "17/01/2017",
        placeOfIdentification:
          "Cục Cảnh sát quản lý hành chính về trật tự xã hội",
        currentAddress: "Thái Thượng-Thái Thụy-Thái Bình",
        permanentAddress: "Triều Khúc-Tân Triều-Hà Nội",
        bankAccount: "",
        bankName: "",
        taxCode: "",
        startTime: "25/08/2025",
        endTime: "",
      },
    ];
    try {
      exportFile(data, columnMapping, "bang_nhan_vien.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleLeaveBalanceEmployeeExportSample = () => {
    const columnMapping = {
      employeeCode: "Mã nhân viên",
      employeeName: "Họ tên",
      year: "Năm",
      remainingLeave: "Ngày nghỉ phép năm",
      compensatoryLeave: "Ngày phép bù",
    };

    const data = [
      {
        employeeCode: "TEST1",
        employeeName: "Trần Mạnh Cường",
        year: 2026,
        remainingLeave: 1,
        compensatoryLeave: 1,
      },
      {
        employeeCode: "TEST2",
        employeeName: "test2",
        year: 2026,
        remainingLeave: 1,
        compensatoryLeave: 0,
      },
    ];
    try {
      exportFile(
        data,
        columnMapping,
        "bang_ngay_nghi_phep_con_lai_cua_nhan_vien.xlsx",
      );
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  return (
    <Box
      minH="calc(100vh - 80px)"
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px 15px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý nhân viên
          </Text>
          <Flex
            justifyContent={{ base: "space-around", xl: "flex-start" }}
            gap={{ base: "24px" }}
          >
            {tabOrder.map((index) => {
              const e = tabEmployee[index];
              return (
                <Flex
                  alignItems={"center"}
                  justifyContent={"center"}
                  key={index}
                  onClick={() => setEmployeeTab(index)}
                  cursor={"pointer"}
                  padding={"12px 5px 0px 5px"}
                  zIndex={"10"}
                >
                  <Text
                    position={"relative"}
                    paddingBottom={"8px"}
                    _before={{
                      content: '""',
                      position: "absolute",
                      bottom: "-1px",
                      left: 0,
                      width: "100%",
                      height: {
                        base: employeeTab === index ? "2px" : "0",
                      },
                      backgroundColor: "var(--color-secondary)",
                    }}
                    fontSize={{
                      base: "16px",
                    }}
                    fontWeight={600}
                    lineHeight={"normal"}
                    fontFamily="var(--font-heading-main)"
                    color={
                      employeeTab === index
                        ? "var(--color-secondary)"
                        : "#9D9D9D"
                    }
                    textAlign={"center"}
                    whiteSpace="nowrap"
                  >
                    {e?.title}
                  </Text>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
        {/* <Button
          display={"flex"}
          alignItems={"center"}
          p={"10px 16px 10px 12px"}
          gap={"8px"}
          backgroundImage="var(--color-button)"
          onClick={onOpen}
          _hover={{
            filter: "brightness(90%)",
          }}
        >
          <Image src={iconButton} />
          <Text
            fontSize={{ base: "15px" }}
            fontWeight={600}
            color="var(--color-main)"
          >
            Thêm nhân viên
          </Text>
        </Button> */}
      </Flex>

      <Flex w={"100%"} mt={4} gap={"16px"}>
        <Button
          w={"240px"}
          h={"44px"}
          as={Button}
          backgroundImage="var(--color-button)"
          _hover={{
            filter: "brightness(96%)",
          }}
          onClick={() => setPopupVisible(true)}
          gap={"16px"}
          p={"10px 16px"}
        >
          <Flex alignItems={"center"} gap={"8px"}>
            <Image src={IconFile} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Import nhân sự
            </Text>
          </Flex>
        </Button>
        <Button
          w={"auto"}
          h={"44px"}
          as={Button}
          backgroundImage="var(--color-button)"
          _hover={{
            filter: "brightness(96%)",
          }}
          onClick={() => setPopupImportLeaveBalanceVisible(true)}
          gap={"16px"}
          p={"10px 16px"}
        >
          <Flex alignItems={"center"} gap={"8px"}>
            <Image src={IconFile} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Import ngày nghỉ phép còn lại
            </Text>
          </Flex>
        </Button>
        <Button
          display={"flex"}
          alignItems={"center"}
          p={"10px 16px 10px 12px"}
          gap={"8px"}
          h={"44px"}
          backgroundImage="var(--linear-gradient-excel)"
          _hover={{
            filter: "brightness(90%)",
          }}
          onClick={handleExport}
        >
          <Image src={iconExcel} />
          <Text
            fontSize={{ base: "15px" }}
            fontWeight={600}
            color="var(--color-main)"
          >
            Xuất excel
          </Text>
        </Button>
        <Menu>
          <MenuButton
            w={"180px"}
            h={"44px"}
            as={Button}
            backgroundImage="var(--color-button)"
            _hover={{
              filter: "brightness(90%)",
            }}
            _active={{
              filter: "brightness(90%)",
            }}
          >
            <Flex alignItems={"center"} p={"10px 0px 10px 0px"} gap={"8px"}>
              <Image src={iconButton} />
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={600}
                color="var(--color-main)"
              >
                Thêm nhân viên
              </Text>
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem
              onClick={() => {
                setSelectedDepartment(0);
                onOpen();
              }}
            >
              Khối hỗ trợ kinh doanh
            </MenuItem>
            <MenuItem
              onClick={() => {
                setSelectedDepartment(1);
                onOpen();
              }}
            >
              Khối kinh doanh
            </MenuItem>
            <MenuItem
              onClick={() => {
                setSelectedDepartment(2);
                onOpen();
              }}
            >
              Ban giám đốc
            </MenuItem>
            <MenuItem onClick={onOpenRelative}>Cộng tác viên</MenuItem>
          </MenuList>
        </Menu>
      </Flex>
      <Box mt={{ base: "23px" }}>{tabEmployee[employeeTab].content}</Box>
      <FormEmployee
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={onSubmit}
        department={selectedDepartment}
      />
      <FormRelative
        isOpen={isOpenRelative}
        onClose={onCloseRelative}
        onSubmit={onSubmitRelative}
      />
      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingEmployee}
          handleExport={handleEmployeeExportSample}
          titleAdd="Thêm nhân sự"
          inputAdd="Nhập danh sách nhân sự"
          type={"employeeImport"}
          // isTypePrice={true}
        />
      )}
      {popupImportLeaveBalanceVisible && (
        <PopupImport
          isOpen={popupImportLeaveBalanceVisible}
          onClose={() => setPopupImportLeaveBalanceVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingLeaveBalanceEmployee}
          handleExport={handleLeaveBalanceEmployeeExportSample}
          titleAdd="Import ngày phép còn lại của nhân viên"
          inputAdd="Nhập danh sách ngày phép còn lại của nhân viên"
          type={"leaveBalanceImport"}
          // isTypePrice={true}
        />
      )}
    </Box>
  );
}
